import get from "lodash/get";
import unset from "lodash/unset";
import { config } from "../config/client";

let configuration;
const getClientConfigValue = key => {
  if (!configuration) {
    const {
      globalKeys: { configKey }
    } = config;
    configuration = get(window, configKey);
    unset(window, configKey);
  }

  return get(configuration, `${key}`);
};

export default getClientConfigValue;
